const ALLOWED_ABSOLUTE_ORIGINS = new Set([
  'https://magicparktimes.com',
  'https://www.magicparktimes.com',
  'https://weather.magicparktimes.com',
  'http://localhost:3000',
  'http://localhost:3002',
  'http://127.0.0.1:3000',
  'http://127.0.0.1:3002',
]);

export const getSafeAuthRedirect = (rawRedirect, fallback = '/dashboard') => {
  if (!rawRedirect || typeof rawRedirect !== 'string') {
    return fallback;
  }

  if (rawRedirect.startsWith('/') && !rawRedirect.startsWith('//')) {
    return rawRedirect;
  }

  try {
    const url = new URL(rawRedirect);
    if (ALLOWED_ABSOLUTE_ORIGINS.has(url.origin)) {
      return url.toString();
    }
  } catch {
    // ignore invalid URL
  }

  return fallback;
};

export const redirectAfterAuth = (redirectTo, navigate, options = {}) => {
  const safeRedirect = getSafeAuthRedirect(redirectTo);

  try {
    if (safeRedirect.startsWith('/')) {
      navigate(safeRedirect, { replace: options.replace !== false });
      return;
    }

    window.location.assign(safeRedirect);
  } catch {
    navigate('/dashboard', { replace: true });
  }
};
